// Auto-generated from menu-item.spec.js
export default {
  "tagName": "menu-item",
  "content": [
    "icon",
    "label",
    "badge"
  ],
  "contentAttributes": [
    "icon",
    "label",
    "badge"
  ],
  "states": [
    "hover",
    "focus",
    "active",
    "disabled"
  ],
  "settings": [
    "href",
    "value"
  ],
  "attributes": [
    "icon",
    "label",
    "badge",
    "hover",
    "focus",
    "active",
    "disabled",
    "href",
    "value"
  ],
  "optionAttributes": {
    "disabled": "disabled",
    "clickable-disabled": "disabled"
  },
  "propertyTypes": {
    "icon": "string",
    "label": "string",
    "badge": "string",
    "hover": "boolean",
    "focus": "boolean",
    "active": "boolean",
    "disabled": "string",
    "href": "string",
    "value": "string"
  },
  "allowedValues": {
    "disabled": [
      "disabled",
      "clickable"
    ]
  },
  "attributeClasses": [
    "icon",
    "disabled"
  ],
  "defaultValues": {
    "href": "",
    "value": ""
  }
};
